var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLampIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.182,
    height: 41.217,
    viewBox: "0 0 39.182 41.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1598",
    x: 0,
    y: 0,
    width: 39.182,
    height: 41.217,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1838",
    "data-name": "Rectangle 1838",
    width: 19.091,
    height: 20.113,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21257",
    "data-name": "Group 21257",
    transform: "translate(-530.987 -238.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9452",
    "data-name": "Group 9452",
    transform: "translate(535.487 241.957)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -3.5)",
    filter: "url(#Rectangle_1598)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1598-2",
    "data-name": "Rectangle 1598",
    width: 30.182,
    height: 32.217,
    rx: 4,
    transform: "translate(4.5 3.5)",
    fill: "#040227"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21252",
    "data-name": "Group 21252",
    transform: "translate(540.604 247.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21250",
    "data-name": "Group 21250",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10895",
    "data-name": "Path 10895",
    d: "M1.514,7.171A1.7,1.7,0,0,0,1.9,10.558l5.957,5.957a1.693,1.693,0,0,0,.132.871H7.161a2.389,2.389,0,0,0-2.386,2.386.341.341,0,0,0,.341.341h8.863a.341.341,0,0,0,.341-.341,2.386,2.386,0,0,0-2.386-2.386h-.824a1.7,1.7,0,0,0-1.751-2.375L3.4,9.053a1.686,1.686,0,0,0,0-.367L8.054,4.034a2.028,2.028,0,0,0,.707.045,4.7,4.7,0,0,0,.892,5.385l1,1a.341.341,0,0,0,.482,0L12.3,9.3a2.727,2.727,0,0,0,3.829-3.829l1.154-1.153a.341.341,0,0,0,0-.482l-1-1a4.7,4.7,0,0,0-5.7-.72c0-.022,0-.045,0-.068a2.045,2.045,0,1,0-4.032.482L1.906,7.172a1.716,1.716,0,0,0-.2-.012,1.7,1.7,0,0,0-.192.011M12.791,8.817l2.856-2.856a2.045,2.045,0,0,1-2.856,2.856m-2.656.165a4.011,4.011,0,0,1-.217-5.428,2.063,2.063,0,0,0,.231-.25,4.006,4.006,0,0,1,5.652.013l.763.763L10.9,9.746l-.763-.763ZM7.724,3.146a1.368,1.368,0,1,1,1.912-.294q-.111.112-.213.23a1.368,1.368,0,0,1-1.7.065M3.155,7.968a1.718,1.718,0,0,0-.538-.543L6.846,3.2a2.061,2.061,0,0,0,.54.541ZM10.569,16.7a1.023,1.023,0,1,1-1.023-1.023A1.023,1.023,0,0,1,10.569,16.7M7.161,18.068H8.525a1.7,1.7,0,0,0,2.043,0h1.365a1.706,1.706,0,0,1,1.67,1.363H5.49a1.707,1.707,0,0,1,1.67-1.363M2.61,10.308a1.718,1.718,0,0,0,.541-.541L8.643,15.26A1.718,1.718,0,0,0,8.1,15.8ZM.684,8.864A1.023,1.023,0,1,1,1.707,9.887,1.023,1.023,0,0,1,.684,8.864",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10896",
    "data-name": "Path 10896",
    d: "M392.659,224.172a.341.341,0,0,0-.482.482l.682.682a.341.341,0,0,0,.482-.482Z",
    transform: "translate(-375.372 -214.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10897",
    "data-name": "Path 10897",
    d: "M336.043,249.4a.341.341,0,0,0,.682,0V248.38a.341.341,0,0,0-.682,0Z",
    transform: "translate(-321.724 -237.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10898",
    "data-name": "Path 10898",
    d: "M408.384,160.721h1.023a.341.341,0,0,0,0-.682h-1.023a.341.341,0,1,0,0,.682",
    transform: "translate(-390.657 -153.22)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampIcon);
export default __webpack_public_path__ + "static/media/lamp-icon.9febfd4782ff8a3e1665d7f5195152aa.svg";
export { ForwardRef as ReactComponent };